import { render } from "./historia.vue?vue&type=template&id=23079e80&scoped=true"
import script from "./historia.vue?vue&type=script&lang=js"
export * from "./historia.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-23079e80"

export default script